import { faArrowRight } from '@fortawesome/pro-light-svg-icons';
import { faCircleChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import { useHttpClient } from '../../shared/hooks/http-hook';
import Influencers from '../components/Influencers';
import Journal from '../components/Journal';
import One2TenTracker from '../components/One2TenTracker';
import TrackerHeading from '../components/TrackerHeading';

function ProductivityTracker(props) {
  const { t } = useTranslation();
  const { sendRequest } = useHttpClient();
  const [isSaved, setIsSaved] = useState(false);
  const [date, setDate] = useState(false);
  const [data, setData] = useState(null);
  const [currentTracker, setCurrentTracker] = useState(null);
  const [journal, setJournal] = useState(null);

  const getData = async (date) => {
    if (date.length > 0) {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_URL}/trackers/productivity/${date}`
        );

        if (response && response.tracker?._id) {
          const { tracker } = response;
          setCurrentTracker({
            id: tracker._id,
            trackerDate: tracker.tracker_date.toString().slice(0, 10),
          });
          const data = JSON.parse(tracker.data);
          setData(data);
          setJournal({
            enhancers: tracker.enhancers,
            inhibitors: tracker.inhibitors,
            journal: tracker.journal,
          });
          setIsSaved(true);
        } else {
          setCurrentTracker({
            id: '',
            trackerDate: date,
          });
          setData({
            productivity: '',
          });
          setJournal(() => ({
            enhancers: [],
            inhibitors: [],
            journal: '',
          }));
        }
      } catch (err) {}
    }
  };

  useEffect(() => {
    getData(date);
  }, [date]);

  const saveResponse = (location, stat) => {
    if (location === 'journal') {
      setJournal((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    } else {
      setData((prevState) => {
        return {
          ...prevState,
          [stat.id]: stat.value,
        };
      });
    }
  };

  const sendData = async () => {
    let method = 'POST';
    let url = `${process.env.REACT_APP_BACKEND_URL}/trackers/`;
    if (currentTracker.id !== '') {
      method = 'PUT';
      url = `${process.env.REACT_APP_BACKEND_URL}/trackers/${currentTracker.id}`;
    }

    try {
      const response = await sendRequest(
        url,
        method,
        JSON.stringify({
          trackerDate: date,
          type: 'productivity',
          data,
          hidden: false,
          enhancers: journal.enhancers,
          inhibitors: journal.inhibitors,
          journal: journal.journal,
          platform: 'web',
        })
      );
      if (response) {
        setIsSaved(true);
        props.closeTrackers();
      }
    } catch (err) {}
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendData();
  };

  return (
    <div
      id="snm-nutrition"
      className="tracker-container"
      role="region"
      aria-label={`${t('T357')} ${t('tracker.region.title')}`}
    >
      <form className="tracker-form" onSubmit={handleSubmit} noValidate={false}>
        <div className="trackers-inner">
          <div className="back-to-main">
            <button
              className="back-btn"
              aria-label={t('A136')}
              title={t('A136')}
              onClick={props.handleBackToMain}
              type="button"
            >
              <FontAwesomeIcon icon={faCircleChevronLeft} />
            </button>
          </div>
          <TrackerHeading title="T047" setDate={setDate} isSaved={isSaved} />
          <div className="trackers-body" role="group" aria-label={t('modal.tracker.details')}>
            <fieldset className="ind-tracker no-padding">
              <legend className="title">{t('T043')}</legend>
              <One2TenTracker
                productivity
                questionid="productivity"
                data={data}
                saveResponse={saveResponse}
                required
              />
              <input
                type="hidden"
                name="productivity"
                value={data?.productivity || ''}
                required
                aria-label={t('T043')}
              />
            </fieldset>
            <fieldset className="no-padding ind-tracker">
              <legend className="title title-with-border" id="productivity-influencers-title">
                {t('T046')}
              </legend>
              <Influencers
                productivity
                questionid={['enhancers', 'inhibitors']}
                data={journal}
                saveResponse={saveResponse}
                greenListAriaLabel={t('trackers.influencers.productivityEnhancers')}
                redListAriaLabel={t('trackers.influencers.productivityInhibitors')}
                titleId="productivity-influencers-title"
              />
            </fieldset>
            <div className="ind-tracker" role="group" aria-label={`${t('T357')} - ${t('T018')}`}>
              <Journal
                placeholder={t('T543')}
                questionid="journal"
                data={journal}
                saveResponse={saveResponse}
              />
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button onClick={props.closeTrackers} variant="secondary" color="dark" type="button">
            {t('T015')}
          </Button>
          <Button type="submit" icon={{ faIconDefinition: faArrowRight }} iconPosition="right">
            {t('T016')}
          </Button>
        </div>
      </form>
    </div>
  );
}
export default ProductivityTracker;
